export let NewUserModalLayoutJSON = [
  {
    name: "New",
    child: [
      {
        child: [
          {
            child: [
              {
                parentid: "1719383677777-col-1",
                elementid: "1719383687656",
                elementtype: "textfield",
              },
              // {
              //   parentid: "1719383677777-col-1",
              //   elementid: "1719383709240",
              //   elementtype: "allmultiselect",
              // },
            ],
            colpos: 1,
            parentid: "1719383677777-columns",
            elementid: "1719383677777-col-1",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
          {
            child: [
              {
                parentid: "1692362019775-col-2",
                elementid: "1719383722105",
                elementtype: "customSelect",
              },
              // {
              //   parentid: "1692362019775-col-2",
              //   elementid: "1719383715621",
              //   elementtype: "textarea",
              // },
            ],
            colpos: 2,
            parentid: "1692362019775-columns",
            elementid: "1692362019775-col-2",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
          {
            child: [
              {
                parentid: "1692362019775-col-2",
                elementid: "1719383715621",
                elementtype: "textarea",
              },
            ],
            colpos: 2,
            parentid: "1692362019775-columns",
            elementid: "1692362019775-col-2",
            elementtype: "column",
            colsizeclass: "col-md-12",
          },
          {
            child: [
              {
                parentid: "1692362019775-col-2",
                elementid: "1719383709240",
                elementtype: "allmultiselect",
              },
            ],
            colpos: 2,
            parentid: "1692362019775-columns",
            elementid: "1692362019775-col-2",
            elementtype: "column",
            colsizeclass: "col-md-12",
          },
        ],
        colsize: 2,
        parentid: "section-1692362014074-form",
        elementid: "1692362019775",
        elementtype: "columns",
      },
    ],
    parentid: "myTabContent",
    elementid: "section-1692362014074",
    description: "",
    elementtype: "others",
    "section-type": "form",
    linkedentitytype: -1,
  },
];
